/**
 * Created by cd01 on 2017/8/21.
 */

{
    angular.module('interfaceModule')
        .controller('advertisingController',advertisingController);
    advertisingController.$inject = ['$scope',"$state",'utils.constant','FileUploader',
        'utils.uploadManager','utils.common',"utils.currentUser","$interval",'utils.platform'];
    function advertisingController($scope,$state,constant,FileUploader,
                            uploadManager,common,currentUser,$interval,platform) {
        let vm=this;
        let collect={
            'activate':activate,
            'isMobile':false,
            'isWechat':false,

            //广告
            'advertisingimg': './../images/bg.jpg',
            'tipSecond': 15,
            'closeAdv':closeAdv,
            'timer': null,

        };
        vm.collect=collect;
        activate();

        function activate(){

            collect.isMobile=platform.isIOS()||platform.isAndroid();
            collect.isWechat=platform.isWechat();

            console.log('定时器时间', collect.tipSecond);
            // console.log('HomeController,activate');
            //获取当前用户：    //要弄清楚监听事件是什么时候开始触发的？？
            // if(currentUser.info){
            //     console.log('home页面当前用户信息');
            //     collect.userInfo=currentUser.info;
            // }else{
            //     $scope.$on('user.logged',function(event,data){
            //         console.log('home页面监听用户信息');
            //         console.log('user.logged',data);
            //         collect.userInfo=data;
            //         $scope.userinfo=data;
            //         if($scope.userinfo.groupname==="企业管理用户"){
            //             //$state.go('main.company',{'userId':$scope.userinfo.userId});
            //         }else if($scope.userinfo.groupname==="合作伙伴"){
            //             //$state.go('main.partner',{'userId':$scope.userinfo.userId});
            //         }
            //     })
            // }

            $scope.$on("$destroy", function(e){
                $interval.cancel(collect.timer);
            });

            if(!collect.isMobile){
                $state.go('main.home');
            }

        }

        //关闭广告
        function closeAdv(){
            console.log('点击关闭广告');
            $interval.cancel(collect.timer);
            $state.go('main.home');

        }

        collect.timer = $interval(function(){
            collect.tipSecond = collect.tipSecond -1 ;
            if(collect.tipSecond <= 0){
                $interval.cancel(collect.timer);
                $state.go('main.home');
            }
        },1000)

    }

}
